/**
 * Features for product type pap.
 */
export enum LicensePapFeature {
  ACCESS_PAP = 'access_pap',
  TRIAL = 'trial',
}
